module.exports = __webpack_public_path__ + "images/79ecc7dac573d7708a70f36852f11194.png";